/* @flow */
import idx from 'idx';
import * as React from 'react';
import { graphql } from 'react-apollo';
import Link from 'components/Link';
import Layer from 'components/Layer';
import LayerTrigger from 'components/LayerTrigger';
import ShortcodeEmoji from 'components/ShortcodeEmoji';
import reactionSettings from 'user/queries/reactionSettings.gql';

import './styles/ReactionPickerTrigger.scss';

type Props = {
  onShow?: ?Function,
  onHide?: ?Function,
  className?: ?string,
  children?: React.Node,
  alignment?: 'left' | 'right',
  addReactionToSummary: Function,
  removeReactionFromSummary: Function,

  /* graphql props */
  reactions: ReactionInventoryItem[],
};

export class ReactionPickerTrigger extends React.Component<Props> {
  static defaultProps = {
    reactions: [],
  };

  _layerPicker = null;

  handleShow = () => {
    if (this.props.onShow) {
      this.props.onShow();
    }
  };

  handleHide = () => {
    if (this.props.onHide) {
      this.props.onHide();
    }
  };

  render() {
    const { alignment, className, children, reactions } = this.props;

    if (reactions.length === 0) {
      return null;
    }

    const reactionPicker = (
      <Layer className="ReactionPickerTrigger">
        {reactions.map(reaction => {
          return (
            reaction.active && (
              <Link
                key={reaction.name}
                className="ReactionPickerTrigger-emoji"
                onClick={() => {
                  if (this._layerPicker) {
                    this._layerPicker.hideLayer();
                  }
                  this.props.addReactionToSummary(reaction.name);
                }}
                eventElementName="ReactionButton-picker-body-emoji">
                <ShortcodeEmoji text={`:${reaction.name}:`} />
              </Link>
            )
          );
        })}
      </Layer>
    );

    return (
      <LayerTrigger
        layer={reactionPicker}
        ref={layerPicker => {
          this._layerPicker = layerPicker;
        }}
        trigger="click"
        placement="bottom"
        alignment={alignment}
        onShow={this.handleShow}
        onHide={this.handleHide}
        hideLayerOnScroll>
        <div className={className}>{children}</div>
      </LayerTrigger>
    );
  }
}

const withReactions = graphql(reactionSettings, {
  props: ({ data }) => {
    const reactions = idx(data, _ => _.settings.reactionInventory.reactions);
    if (!reactions) {
      return {};
    }

    return { reactions };
  },
});

export default withReactions(ReactionPickerTrigger);
